(() => {
  const headers = Array.from(document.querySelectorAll('[data-adyjo-header]'));
  if (!headers.length) return;

  const scrollLockClass = 'adyjo-scroll-lock';

  const getHeader = () => headers[0] || null;

  const getHeaderHeight = () => {
    const header = getHeader();
    return header ? Math.ceil(header.getBoundingClientRect().height) : 0;
  };

  const setScrollLock = (locked) => {
    document.documentElement.classList.toggle(scrollLockClass, locked);
    document.body.classList.toggle(scrollLockClass, locked);
  };

  const closeMenu = (header) => {
    if (!header) return;
    header.classList.remove('adyjo-header--menu-open');
    header.dataset.menuOpen = 'false';

    const toggle = header.querySelector('[data-adyjo-toggle]');
    const mobile = header.querySelector('[data-adyjo-mobile]');
    const backdrop = header.querySelector('[data-adyjo-backdrop]');

    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (mobile) {
      mobile.hidden = true;
      mobile.setAttribute('aria-hidden', 'true');
    }
    if (backdrop) backdrop.hidden = true;

    setScrollLock(false);
  };

  const openMenu = (header) => {
    if (!header) return;
    header.classList.add('adyjo-header--menu-open');
    header.dataset.menuOpen = 'true';

    const toggle = header.querySelector('[data-adyjo-toggle]');
    const mobile = header.querySelector('[data-adyjo-mobile]');
    const backdrop = header.querySelector('[data-adyjo-backdrop]');

    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (mobile) {
      mobile.hidden = false;
      mobile.setAttribute('aria-hidden', 'false');
    }
    if (backdrop) backdrop.hidden = false;

    setScrollLock(true);
  };

  const toggleMenu = (header) => {
    if (!header) return;
    const isOpen = header.dataset.menuOpen === 'true';
    if (isOpen) closeMenu(header);
    else openMenu(header);
  };

  const scrollToTarget = (hash) => {

    if (!hash || hash === '#') return false;

    const id = hash.replace('#','');

    let target =
        document.getElementById(id) ||
        document.querySelector(`[id="${id}"]`) ||
        document.querySelector(`[data-section-id="${id}"]`) ||
        document.querySelector(hash);

    if (!target) return false;

    const headerHeight =
        document.querySelector('.adyjo-header')?.offsetHeight || 70;

    const y =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight -
        8;

    window.scrollTo({
        top:y,
        behavior:'smooth'
    });

    return true;
};

  const setActiveLinks = () => {
    const header = getHeader();
    if (!header) return;

    const links = Array.from(header.querySelectorAll('[data-adyjo-link], [data-adyjo-mobile-link]'));
    if (!links.length) return;

    const threshold = getHeaderHeight() + Math.max(80, window.innerHeight * 0.22);
    const candidates = Array.from(document.querySelectorAll('section[id], header[id], div[id], main[id], article[id]'))
      .filter((el) => el.id && !el.id.startsWith('shopify'));

    let activeId = '';

    for (const candidate of candidates) {
      const rect = candidate.getBoundingClientRect();
      if (rect.top <= threshold && rect.bottom > threshold) {
        activeId = candidate.id;
        break;
      }
    }

    if (!activeId) {
      let nearest = null;
      let nearestDistance = Infinity;

      for (const candidate of candidates) {
        const rect = candidate.getBoundingClientRect();
        const distance = Math.abs(rect.top - threshold);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearest = candidate;
        }
      }

      activeId = nearest ? nearest.id : '';
    }

    links.forEach((link) => {
      const href = link.getAttribute('href') || '';
      const targetId = href.startsWith('#') ? href.slice(1) : '';
      const isActive = Boolean(activeId) && targetId === activeId;
      link.classList.toggle('is-active', isActive);
      if (isActive) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  };

  const onScroll = () => {

    headers.forEach((header)=>{

        if(window.scrollY > 10){

            header.classList.add('is-scrolled');

        }else{

            header.classList.remove('is-scrolled');

        }

    });

    window.requestAnimationFrame(setActiveLinks);

};

  headers.forEach((header) => {
    const toggle = header.querySelector('[data-adyjo-toggle]');
    const mobile = header.querySelector('[data-adyjo-mobile]');
    const backdrop = header.querySelector('[data-adyjo-backdrop]');
    const closeBtn = header.querySelector('[data-adyjo-close]');

    header.dataset.menuOpen = 'false';
    if (mobile) {
      mobile.hidden = true;
      mobile.setAttribute('aria-hidden', 'true');
    }
    if (backdrop) backdrop.hidden = true;

    if (toggle) {
      toggle.addEventListener('click', () => toggleMenu(header));
    }

    if (backdrop) {
      backdrop.addEventListener('click', () => closeMenu(header));
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => closeMenu(header));
    }

    header.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href');
        if (!href || href === '#') return;

        const matched = scrollToTarget(href);
        if (matched) {
          event.preventDefault();
          closeMenu(header);
        }
      });
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      headers.forEach((header) => closeMenu(header));
    }
  });

  document.addEventListener('click', (event) => {
    const header = getHeader();
    if (!header) return;
    if (!event.target.closest || !event.target.closest('[data-adyjo-header]')) {
      closeMenu(header);
    }
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => {
    const header = getHeader();
    if (header && window.innerWidth >= 990) {
      closeMenu(header);
    }
    setActiveLinks();
  });
  window.addEventListener('load', setActiveLinks);

  onScroll();
})();
